import React from "react";
import AuthLayout from "../../layouts/AuthLayout";
import { BsLock } from "react-icons/bs";
function Reset() {
  const style = {
    loginBtn:
      "w-full bg-indigo-500 text-white px-4 py-3 rounded hover:bg-indigo-600  mr-4 font-medium text-xs flex flex-row",
    field: {
      parentDiv:
        "border border-indigo-200 py-3 px-3 rounded flex flex-row focus-within:border-indigo-500",
      input: "h-full w-4/5 focus:outline-none",
      icon: "m-auto ml-0 mr-1 hidden",
    },
  };
  return (
    <AuthLayout>
      <div className="flex flex-row text-white m-auto min-h-full w-full">
        {/* reset form */}
        <div className="bg-white rounded p-8 text-gray-500 w-80">
          <h2 className="font-semibold text-xs">Guhindura ijambobanga</h2>
          <div className="py-4 text-xs">
            {/* password field */}
            <div className="py-2">
              <label>Ijambobanga rishya </label>
              <div className={style.field.parentDiv}>
                <BsLock className={style.field.icon} />
                <input
                  type="password"
                  placeholder="Andika ijambobanga "
                  className={style.field.input}
                />
              </div>
            </div>
            {/* password field */}
            <div className="py-2">
              <label>Ijambo ry'ibanga </label>
              <div className={style.field.parentDiv}>
                <BsLock className={style.field.icon} />
                <input
                  type="password"
                  placeholder="Emeza ijambobanga"
                  className={style.field.input}
                />
              </div>
            </div>
            {/* reset btn */}
            <button type="submit" className={style.loginBtn}>
              <p className="m-auto">Hindura</p>
            </button>
          </div>
        </div>
      </div>
    </AuthLayout>
  );
}

export default Reset;
